<script setup>
  const emits = defineEmits(['commit']);
  const model = defineModel();
  const props = defineProps({
    label: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    },
  });
</script>


<template>
  <div class="w-100">
    <v-text-field density="compact" v-if="editing" :label="label" @keyup.enter="emits('commit')" v-model="model" />
    <slot v-else>
      {{ model }}
    </slot>
  </div>
</template>
